import { GET_MAKE_REQUEST, GET_MAKE_SUCCESS, GET_MAKE_FAIL, 
    GET_MODEL_REQUEST, GET_MODEL_SUCCESS, GET_MODEL_FAIL, 
    GET_INSURANCECOMPANY_REQUEST, GET_INSURANCECOMPANY_SUCCESS, GET_INSURANCECOMPANY_FAIL,
    GET_PRODUCTLIST_REQUEST, GET_PRODUCTLIST_SUCCESS, GET_PRODUCTLIST_FAIL,
    GET_VEHICLE_REQUEST, GET_VEHICLE_SUCCESS, GET_VEHICLE_FAIL  } from '../types/getApiTypes'

function getVehicleReducer( state = { vehicle: [] }, action) {
    switch (action.type) {
        case GET_VEHICLE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VEHICLE_SUCCESS: 
            return {
                ...state,
                vehicle: action.payload,
                isLoading: false
            }
        case GET_VEHICLE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}
        

function insuranceCompanyReducer( state = { insuranceCompany: [] }, action) {
    switch (action.type) {
        case GET_INSURANCECOMPANY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_INSURANCECOMPANY_SUCCESS: 
            return {
                ...state,
                insuranceCompany: action.payload,
                isLoading: false
            }
        case GET_INSURANCECOMPANY_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}
    
function modelReducer( state = { model: [] }, action) {
    switch (action.type) {
        case GET_MODEL_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_MODEL_SUCCESS: 
            return {
                ...state,
                model: action.payload,
                isLoading: false
            }
        case GET_MODEL_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function makeReducer( state = { make: [] }, action) {
    switch (action.type) {
        case GET_MAKE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_MAKE_SUCCESS: 
            return {
                ...state,
                make: action.payload,
                isLoading: false
            }
        case GET_MAKE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function getProductReducer( state = { product: [] }, action) {
    switch (action.type) {
        case GET_PRODUCTLIST_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PRODUCTLIST_SUCCESS: 
            return {
                ...state,
                product: action.payload,
                isLoading: false
            }
        case GET_PRODUCTLIST_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { makeReducer, modelReducer, insuranceCompanyReducer, getProductReducer, getVehicleReducer }